<template>
  <div class="format-badge">
    <div class="account avatar" v-if="type === 'account'">
      <avatar :account="{avatar: avatar}" :alt="name || ''" :size="32" />
    </div>
    <template v-else>
      <div class="format" v-if="extension !== ''"
          :style="{'background-color': colorHelper.fromExtension(extension.toUpperCase())}">
        <span>{{extension.length > 4 ? extension.toUpperCase().substring(0, 3) + '…' : extension.toUpperCase()}}</span>
      </div>
      <template v-else>
        <div class="root-icon" v-if="icon !== '' && type === ''">
          <img v-if="icon === 'link'" src="/static/images/magic-link-dark.svg" />
          <v-icon v-else>{{icon}}</v-icon>
        </div>
        <div class="icon" v-if="type !== '' && extension === ''"
            :style="{'background-color': colorHelper.fromType('', color)}">
          <v-icon class="white--text">{{iconFromType}}</v-icon>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import colorHelper from '~/helpers/color'
  import {IconFromType} from '~/helpers/icon.js'

  export default {
    name: 'format-badge',
    props: {
      icon: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      },
      extension: {
        type: String,
        default: ''
      },
      avatar: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: null
      },
      name: String
    },
    data () {
      return {
        colorHelper: colorHelper
      }
    },
    computed: {
      iconFromType () {
        return IconFromType(this.type)
      }
    }
  }
</script>
<style type="scss">
  .menu__content .account.avatar {
    min-width: 0;
  }
</style>
<style type="scss" scoped>
  .icon, .root-icon, .format {
    display: flex;
    align-content: center;
    justify-content: center;
    color: white;
  }

  .icon, .root-icon {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    color: inherit;
    align-items: center;
  }

  .format {
    height: 25px;
    border-radius: 2px;
    padding: 2px 4px;
  }

  .format span {
    line-height: 21px;
    display: block;
    margin: auto;
    padding: 0;
  }

  .avatar {
    border-radius: 50%;
    height: 32px;
    width: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/files/FormatBadge.vue